/* ============================================================
   HIT: o "Comprar" direto do card (direção de 19/10/2026, §4). Só o botão <button data-card-add="<id da variante>"> faz isto, e o
   snippets/card-produto.liquid só o desenha quando a compra está inteira: produto sem opção nenhuma (uma variante só), com estoque, fora de
   um grupo e sem irmãos a escolher. Qualquer outro card tem um link para a página do produto, que este módulo não toca.
   Fluxo: POST /cart/add.js com a variante (quantidade 1) e a seção da gaveta; sucesso entrega a resposta a HitSacola.sincroniza (o número e o
   nome do link da sacola vêm de passagem) e abre a gaveta da sacola (HitGaveta.abrir). O rótulo do botão não muda ("Comprar"): enquanto o
   pedido está no ar ele ganha aria-busy="true" (o CSS pinta o bloqueio com os tokens de desabilitado) e a região viva diz "Adicionando à
   sacola…". Sucesso: "Produto adicionado à sacola." e a gaveta aberta. Falha: "Não foi possível adicionar. Tente novamente." na região viva
   e no aviso (#toast) para quem enxerga, e o botão volta. Os textos vêm do locale por HitConfig.textos (adicionando, adicionado, falhaAdicionar). Sem resposta em PRAZO ms (HitSacola.prazo) o pedido é cortado e conta como falha;
   a loja pode ter recebido o item, e nesse caso a gaveta, no próximo clique dela, relê a sacola. Sem o hit-sacola.js não há como sincronizar:
   falha. O botão nunca fica preso: o aria-busy sai em qualquer desfecho.
   Delegado no document: serve o card do servidor e o que o JS desenha depois. Um clique em andamento ignora o seguinte (sem item duplicado).
   ============================================================ */
(function () {
  'use strict';
  if (window.HitCard) return;
  const RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECAO = 'cart-drawer';
  const PRAZO = 15000; // ms
  const AVISO_MS = 3600;
  const aviso = (msg, e) => console.warn(`hit-card.js: ${msg}`, e || '');
  const textos = () => (window.HitConfig && window.HitConfig.textos) || {};

  /* a região viva única da loja para este módulo: o leitor de tela só lê a mudança de um nó que continua */
  function viva() {
    let r = document.getElementById('card-anuncio');
    if (!r) {
      r = document.createElement('div');
      r.id = 'card-anuncio';
      r.className = 'sr';
      r.setAttribute('role', 'status');
      r.setAttribute('aria-live', 'polite');
      document.body.appendChild(r);
    }
    return r;
  }
  const anuncia = (texto) => { const r = viva(); r.textContent = ''; r.textContent = texto || ''; };
  let relogio = 0;
  function toast(msg) {
    const t = document.getElementById('toast');
    if (!t || !msg) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(relogio);
    relogio = setTimeout(() => { t.hidden = true; }, AVISO_MS);
  }

  async function adiciona(variante) {
    const S = window.HitSacola;
    if (!S) { aviso('o hit-sacola.js não carregou: sem gaveta para sincronizar'); return false; }
    const marca = S.marca(); // a gaveta mexeu até a resposta chegar? Então as seções do add já são velhas
    const p = S.prazo(PRAZO);
    let j = null;
    try {
      const r = await fetch(`${RAIZ}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }], sections: SECAO }),
        signal: p.signal,
      });
      if (!r.ok || r.redirected) { aviso(`o /cart/add.js recusou (HTTP ${r.status}${r.redirected ? ', redirecionado' : ''})`); return false; }
      j = await r.json().catch(() => null);
    } catch (e) {
      aviso('o /cart/add.js não respondeu', e);
      return false;
    } finally { p.limpa(); }
    await S.sincroniza(j && j.sections, marca); // na fila da gaveta: uma resposta velha nunca sobrescreve a nova
    return true;
  }

  async function aoClicar(ev) {
    const b = ev.target && ev.target.closest ? ev.target.closest('[data-card-add]') : null;
    if (!b) return;
    ev.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    const T = textos();
    b.setAttribute('aria-busy', 'true');
    anuncia(T.adicionando);
    let ok = false;
    try { ok = await adiciona(b.getAttribute('data-card-add')); } catch (e) { aviso('erro ao adicionar', e); }
    b.removeAttribute('aria-busy');
    if (ok) {
      anuncia(T.adicionado);
      if (window.HitGaveta && window.HitGaveta.tem('sacola')) window.HitGaveta.abrir('sacola', b);
    } else {
      anuncia(T.falhaAdicionar);
      toast(T.falhaAdicionar);
    }
  }
  document.addEventListener('click', aoClicar);
  window.HitCard = Object.freeze({ adiciona });
})();
